import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/nenkin_01_260325.png")